import styled from 'styled-components';

import CalendarLegend from '../shared/CalendarLegend';

import MonthDateNavigation from './MonthDateNavigation';
import MonthViewGrid from './MonthViewGrid';

export default function MonthView() {
  return (
    <Container>
      <Header>
        <MonthDateNavigation />
        <CalendarLegend />
      </Header>
      <CalendarContainer>
        <MonthViewGrid />
      </CalendarContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const CalendarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px ${({ theme }) => theme.colors.boxShadow};
`;
